import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { ServiceBase } from './service.base';

export interface ResponseObject {
  Success: boolean;
  ResponseMessage: string;
  ResponseData?: any;
}

@Injectable({
  providedIn: 'root'
})
export class GalleryStaffService extends ServiceBase {
  public api = '/GalleryStaff';

  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }

  public SaveGalleryStaff(staff: SaveGalleryStaffRequest): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/save';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, staff, httpOptions);
  }

  public FetchGalleryStaff(galleryId: string | null = null): Observable<SaveGalleryStaffRequest[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/fetch/' + galleryId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SaveGalleryStaffRequest[]>(url, httpOptions);
  }

  public getGalleryStaffByPosition(position: string): Observable<SaveGalleryStaffRequest[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/${position}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SaveGalleryStaffRequest[]>(url, httpOptions);
  }

  public DeleteGalleryStaff(galleryStaffId: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/delete/';
    const url: string = environment.BASE_API_PATH + this.api + method + galleryStaffId;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

  public FetchStaffByRole(roleEnum: number): Observable<SaveGalleryStaffRequest[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/fetch/position/staff?galleryStaffRoleEnum=${roleEnum}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SaveGalleryStaffRequest[]>(url, httpOptions);
  }
}

export class SaveGalleryStaffRequest {
  Id?: string;
  GalleryId?: string;
  Name?: string;
  FirstName?: string;
  LastName?: string;
  Email?: string;
  Password?: string;
  PhoneNumber?: string;
  GalleryStaffPosition?: string;
  GalleryStaffNotes?: string;
}